import { QuoteSmall } from '@wix/wix-ui-icons-common';

import { BLOCKQUOTE } from './../../ricos-content';
import { Node_Type } from './../../ricos-schema/legacy/wix/rich_content/v1';
import type { EditorPlugin } from './../../ricos-types';
import { createShortcut, quickActionsModalSections } from './../../ricos-types';
import { RESOLVERS_IDS } from './../../toolbars-v3/lib/resolvers-ids';

import { blockquoteConverter } from './blockquote-converter';
import BlockQuoteIcon from './BlockQuoteIcon';
import { TEXT_BUTTON_BLOCKQUOTE } from './data-hooks';
import { blockquote } from './extension';

export const pluginBlockquote: EditorPlugin = {
  type: Node_Type.BLOCKQUOTE,
  config: {},
  pmMarkConverters: [],
  pmNodeConverters: [blockquoteConverter],
  tiptapExtensions: [blockquote],
  shortcuts: [
    createShortcut({
      name: Node_Type.BLOCKQUOTE,
      description: 'ShortcutsSheet_Formatting_Quote',
      keys: { macOs: 'Meta+Shift+9', windows: 'Ctrl+Shift+9' },
      command({ publicCommands }) {
        publicCommands.setBlockType(BLOCKQUOTE);
      },
      group: 'ShortcutsSheet_Section_Formatting',
      enabled: true,
    }),
  ],
  textButtons: [
    {
      id: Node_Type.BLOCKQUOTE,
      type: 'toggle',
      presentation: {
        dataHook: TEXT_BUTTON_BLOCKQUOTE,
        tooltip: 'QuoteButton_Tooltip',
        icon: BlockQuoteIcon,
      },
      attributes: {
        visible: RESOLVERS_IDS.ALWAYS_VISIBLE,
        active: RESOLVERS_IDS.IS_TEXT_CONTAINS_QUOTE,
        disabled: RESOLVERS_IDS.IS_NODE_OR_CAPTION_SELECTED,
      },
      command:
        ({ publicCommands }) =>
        () => {
          publicCommands.setBlockType(BLOCKQUOTE);
          return true;
        },
    },
  ],
  getQuickActions: () => [
    {
      id: 'blockquote',
      title: 'QuickActionsPlugin_ActionTitle_Quote',
      icon: QuoteSmall,
      section: quickActionsModalSections.FormatLayout,
      tags: ['quote', 'text highlight', 'citation', 'reference', 'highlight', 'saying', 'excerpt'],
      command: ({ publicCommands }) => publicCommands.setBlockType(BLOCKQUOTE),
    },
  ],
};
